/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
} from '@wordpress/block-editor';

/**
 * Icons
 */
import icons from './icons.js';
/**
 * Internal dependencies
 */
import Edit from './edit';
//import Edit__ from './edit__.js';
import save from './save';
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( 'tecslider/tecsb-slider-block', {
    title: __( 'EventGlide', 'tecslider' ),
    description: __( 'Events Slider for The Events Calendar.', 'tecslider' ),
    icon: icons.slider,
    category: 'media',
    attributes: {
        plugin: {
            type: 'string',
            default: 'tec',
        },
        sliderTheme: {
            type: 'string',
            default: 'datetop',
        },
        sliderType: {
            type: 'string',
            default: 'upcoming'
        },
        eventInRow: {
            type: 'number',
            default: 3
        },
        eventInSlide: {
            type: 'number',
            default: 3
        },
        autoplay: {
            type: 'string',
        },
        transitionDelay: {
            type: 'string',
        },
        colorScheme: {
            type: 'string',
            default: '#5a30f3',
        },
        blockId: {
            type: 'string',
        },
        customSelectedEvents: {
            type: 'string',
            default: null,
        },
        newtab: {
            type: 'boolean',
            default: true,
        },
        category: {
            type: 'string',
            default: '',
        },
        titleFontFace: {
            type: 'string',
            default: '',
        },
        titleFontSize: {
            type: 'number',
            default: 20,
        },
        datetimeFontFace: {
            type: 'string',
            default: '',
        },
        datetimeFontSize: {
            type: 'number',
            default: 0,
        },
        descFontFace: {
            type: 'string',
            default: '',
        },
        descFontSize: {
            type: 'number',
            default: 14,
        },
        countdownTimer: {
            type: 'boolean',
            default: false,
        },
        dots: {
            type: 'boolean',
            default: false,
        },
        darkmode: {
            type: 'boolean',
            default: false,
        },
        slideHeight: {
            type: 'number',
            default: 0,
        },
        imageHeight: {
            type: 'number',
            default: 0,
        }
    },
    keywords: [
        __( 'tecsb', 'tecslider' ),
        __( 'slider', 'tecslider' ),
        __( 'events', 'tecslider' ),
        __( 'glide', 'tecslider' ),
        __( 'eventglide', 'tecslider' ),
    ],
    /**
     * @see ./edit.js
     */
    edit: Edit,

    /**
     * @see ./save.js
     */
    save: save,
} );
